import { Nullable } from '@clearverify/types';

import { PeoInfoFragment } from 'src/api';
import { AddressFieldsFormFields } from 'src/constants/address';

import { PeoCompanyInformationFormFields, PeoCompanyInformationFormValues } from '../types';

export const getPeoCompanyInformationInitialValues = (
  peo: Nullable<PeoInfoFragment>,
): Partial<Omit<PeoCompanyInformationFormValues, 'headquarters'>> & {
  headquarters?: Partial<PeoCompanyInformationFormValues['headquarters']>;
} => ({
  [PeoCompanyInformationFormFields.displayName]: peo?.displayName ?? undefined,
  [PeoCompanyInformationFormFields.fein]: peo?.fein ?? undefined,
  [PeoCompanyInformationFormFields.industry]: peo?.industry
    ? { label: peo.industry, value: peo.industry }
    : undefined,
  [PeoCompanyInformationFormFields.corporateStructure]: peo?.corporateStructure,
  [PeoCompanyInformationFormFields.numberOfEmployees]: peo?.numberOfEmployees,
  [PeoCompanyInformationFormFields.contactEmail]: peo?.contactEmail ?? undefined,
  [PeoCompanyInformationFormFields.contactPhoneNumber]: peo?.contactPhoneNumber,
  [PeoCompanyInformationFormFields.taxYearEndDate]: peo?.taxYearEndDate,
  [PeoCompanyInformationFormFields.defaultDisclaimer]: peo?.defaultDisclaimer,
  [PeoCompanyInformationFormFields.headquarters]: peo?.headquarters
    ? {
        [AddressFieldsFormFields.street]: peo?.headquarters.street ?? undefined,
        [AddressFieldsFormFields.city]: peo?.headquarters.city ?? undefined,
        [AddressFieldsFormFields.county]: peo?.headquarters.county,
        [AddressFieldsFormFields.state]: peo?.headquarters.state ?? undefined,
        [AddressFieldsFormFields.zipCode]: peo?.headquarters.zipCode ?? undefined,
      }
    : undefined,
});
